import { Injectable } from "@angular/core";
import { LazyService } from "./lazy.service";
import { msalConfig } from "./azure-config";
import { AppService } from "../shared/services/app.service";

declare var msal:any;
@Injectable({
    providedIn: 'root'
})
export class ADService {

    constructor(public appService:AppService,public lazyService:LazyService){

    }
    adObj:any = {disabled:true,adConfigs:[]};
    initloginWithAD(callback){
        let adConfigs = this.appService.getAdConfigs();
        if(adConfigs.length>0){
          this.adObj.adConfigs = adConfigs;
        }else{
          callback(false);
          return;
        }

        if(this.adObj.instances != undefined){
          callback(true);
          return;
        }
        var promises = [];
        this.adObj.instances = {};
        var script = {
          'azure': { 'name': 'msal-browser.min.js' },
          'oauth2': { 'name': null }
        }
        
        for (let index = 0; index < this.adObj.adConfigs.length; index++) {
          const element = this.adObj.adConfigs[index];
          const providerType = this.normalizeProviderType(element.type);
          if(providerType === 'oauth2'){
            this.adObj.instances[element.type] = {};
            this.adObj.instances[element.type].config = element;
          } else if(script[providerType]?.name){
            promises.push(this.lazyService.loadScript("/assets/js/"+ script[providerType].name));
            this.adObj.instances[element.type] = {};
            this.adObj.instances[element.type].config = {};
            switch (providerType) {
              case 'Azure':
              case 'azure':
                var msalConfigObj = JSON.parse(JSON.stringify(msalConfig));
                this.adObj.instances[element.type].scope = [element.client_id+"/.default"];
                msalConfigObj.auth.clientId = element.client_id;
                msalConfigObj.auth.authority = msalConfigObj.auth.authority+element.tenant_id;
                msalConfigObj.auth.redirectUri = window.location.origin+msalConfigObj.auth.redirectUri;
                msalConfigObj.auth.postLogoutRedirectUri = window.location.origin+msalConfigObj.auth.postLogoutRedirectUri;
                this.adObj.instances[element.type].config = msalConfigObj;
                break;
            
              default:
                break;
            }
          }
        }
        Promise.all(promises).then((res) => {
          this.adObj.disabled = false;
          for (let index = 0; index < this.adObj.adConfigs.length; index++) {
            const element = this.adObj.adConfigs[index];
            if(this.normalizeProviderType(element.type) !== 'oauth2' && this.adObj.instances[element.type] != undefined && this.adObj.instances[element.type].config != undefined){
              this.adObj.instances[element.type].adClient = new msal.PublicClientApplication(this.adObj.instances[element.type].config);
            }
          }
          callback(true);
        }).catch((error) => {
          console.error(error);
          callback(false);
        });
        
      }
    
      loginWithAD(type?: string){
        let providerConfig = this.getProviderConfig(type);
        type = providerConfig && providerConfig.type ? providerConfig.type : type;
        switch(this.normalizeProviderType(type)){
          case 'azure':
            this.adObj.instances[type].adClient["browserStorage"].clear();
            this.adObj.instances[type].adClient.loginRedirect({
              scopes:this.adObj.instances[type].scope});
            break;
          case 'oauth2':
            return this.loginWithOAuth2PKCE(providerConfig);
          default:
            console.warn('Unknown SSO type:', type);
            break;
        }
        return Promise.resolve();
      }

      getPrimaryProviderConfig() {
        return this.getProviderConfig();
      }

      getConfiguredProviderType(type?: string): string {
        const providerConfig = this.getProviderConfig(type);
        return providerConfig ? providerConfig.type : undefined;
      }

      private getProviderConfig(type?: string) {
        let configs = this.adObj.adConfigs && this.adObj.adConfigs.length ? this.adObj.adConfigs : this.appService.getAdConfigs();
        if(!configs || !configs.length){
          return undefined;
        }
        if(type){
          const matchingConfig = configs.find(config => this.normalizeProviderType(config.type) === this.normalizeProviderType(type));
          if(matchingConfig){
            return matchingConfig;
          }
          return undefined;
        }
        return configs[0];
      }

      isADLogin(){
          let ad_user = localStorage.getItem("ad_user");
          if(ad_user != null){
              return ad_user;
          }
          return false;
      }

      getADUserFullName(){
        let adName = localStorage.getItem("ad_name");
        if(adName != null){
            return adName;
        }
        return false;
    }

      adLogout(adType,logoutHint){
        if(adType != null && logoutHint != null){
          if(this.normalizeProviderType(adType) != "azure"){
            let config = this.getProviderConfig(adType);
            this.removeAdObj();
            if(config && config.logout_url){
              window.location.href = config.logout_url;
            }else{
              window.location.href = window.location.origin + "/";
            }
            return;
          }
          this.removeAdObj();
          this.adObj.instances[adType].adClient.logout({
            logoutHint: logoutHint
          });          
        }
      }

      removeAdObj(){
        localStorage.removeItem("ad_user")
        localStorage.removeItem("ad_ac")
        localStorage.removeItem("ad_name")
        localStorage.removeItem("ad_type")
        localStorage.removeItem("ad_patient")
        localStorage.removeItem("ad_id_token")
        localStorage.removeItem("ad_access_token")
        localStorage.removeItem("kc_code_verifier")
        localStorage.removeItem("kc_state")
      }

      async loginWithOAuth2PKCE(config){
        if(!config || !config.authorization_endpoint || !config.client_id){
          throw new Error("OAuth2 provider configuration is invalid.");
        }
        const codeVerifier = this.base64UrlEncode(this.getRandomBytes(64));
        const codeChallenge = await this.createCodeChallenge(codeVerifier);
        const state = this.base64UrlEncode(this.getRandomBytes(32));
        const redirectUri = window.location.origin + '/sso-redirect';

        localStorage.setItem('kc_code_verifier', codeVerifier);
        localStorage.setItem('kc_state', state);

        const authorizationUrl = new URL(config.authorization_endpoint);
        authorizationUrl.searchParams.set('response_type', 'code');
        authorizationUrl.searchParams.set('client_id', config.client_id);
        authorizationUrl.searchParams.set('redirect_uri', redirectUri);
        authorizationUrl.searchParams.set('scope', 'openid profile email');
        authorizationUrl.searchParams.set('state', state);
        authorizationUrl.searchParams.set('code_challenge', codeChallenge);
        authorizationUrl.searchParams.set('code_challenge_method', 'S256');
        // authorizationUrl.searchParams.set('prompt', 'login');
        // authorizationUrl.searchParams.set('max_age', '0');

        window.location.assign(authorizationUrl.toString());
      }

      private getRandomBytes(length: number): Uint8Array {
        const bytes = new Uint8Array(length);
        window.crypto.getRandomValues(bytes);
        return bytes;
      }

      private async createCodeChallenge(codeVerifier: string): Promise<string> {
        if(!window.crypto || !window.crypto.subtle){
          throw new Error("Browser does not support Web Crypto API.");
        }
        const digest = await window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
        return this.base64UrlEncode(new Uint8Array(digest));
      }

      private base64UrlEncode(bytes: Uint8Array): string {
        let value = '';
        bytes.forEach(byte => value += String.fromCharCode(byte));
        return btoa(value).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
      }

      private normalizeProviderType(type: string): string {
        return (type || '').toString().trim().toLowerCase();
      }
}
